import { useEffect, useState } from 'react';
import { useDocumentTitle } from '~src/hooks/useDocumentTitle';
import styles from './index.module.less';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const privacyPolicyMd = process.env.REACT_APP_PRIVACY_POLICY;

const PrivacyPolicy = ({ type }: { type?: "life" }) => {
  const [md, setMd] = useState("");

  useDocumentTitle('隐私政策');

  useEffect(() => {
    fetch(privacyPolicyMd ?? "").then(res => {
      return res.text();
    }).then(text => {
      let str = text;
      if (type == "life") {
        str = text.replaceAll("绿喵", "绿喵生活");
      }
      setMd(str);
    })
  }, [])

  return <div className={styles.mdContainer}>
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
    >{md}</ReactMarkdown>
  </div>
}
export default PrivacyPolicy
